module.exports = __webpack_public_path__ + "img/c24c6cbe.png";